// src/utils/servertranslate.ts
import store from '@/store';

export default function servertranslate(value: any, key = store.state.lang.lang) {
  let langObject = { ar: '', en: '' };

  if (value) {
    if (typeof value === 'string') {
      try {
        langObject = JSON.parse(value);
      } catch {
        return value;
      }
    } else if (typeof value === 'object' && value[key]) {
      langObject = value;
    }
  }

  return langObject[key] || '';
}
